import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Extend the Window interface to include Cypress for type safety
declare global {
  interface Window {
    Cypress?: any;
  }
}

import { getEntity, updateEntity, createEntity, reset } from './matiere-ecole.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MatiereEcoleUpdate = (props: RouteComponentProps<{ ecoleid: string; id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const matiereEntity = useAppSelector(state => state.matiereEcole.entity);
  const loading = useAppSelector(state => state.matiereEcole.loading);
  const updating = useAppSelector(state => state.matiereEcole.updating);
  const updateSuccess = useAppSelector(state => state.matiereEcole.updateSuccess);
  const { ecoleid, id } = props.match.params;
  const handleClose = () => {
    props.history.push(`/matiere-ecole/${ecoleid}/`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...matiereEntity,
      ...values,
      ecoleId: ecoleid,
    };
    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...matiereEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="korischoolApp.matiere.home.createOrEditLabel" data-cy="MatiereCreateUpdateHeading">
            <Translate contentKey="korischoolApp.matiere.home.createOrEditLabel">Create or edit a Matiere</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="matiere-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('korischoolApp.matiere.nom')} id="matiere-nom" name="nom" data-cy="nom" type="text" />
              <ValidatedField
                label={translate('korischoolApp.matiere.color')}
                id="matiere-color"
                name="color"
                data-cy="color"
                type={window.Cypress ? 'text' : 'color'}
              />
              <Button onClick={() => props.history.goBack()} id="cancel-save" data-cy="entityCreateCancelButton" color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default MatiereEcoleUpdate;
